import { createAction } from '@reduxjs/toolkit';
export const openDialog = createAction('curveManager/dialog/open');
export const closeDialog = createAction('curveManager/dialog/close');
export const openDeleteModal = createAction('curveManager/deleteModal/open');
export const closeDeleteModal = createAction('curveManager/deleteModal/close');
export const openOverwriteModal = createAction('curveManager/overwriteModal/open');
export const closeOverwriteModal = createAction('curveManager/overwriteModal/close');
export const tableAction = createAction('curveManager/tableAction');
export const setCurveData = createAction('curveManager/setCurveData');
export const getCurves = createAction('curveManager/getCurves');
export const getCurvesResolved = createAction('curveManager/getCurves/resolved');
export const getCurvesRejected = createAction('curveManager/getCurves/rejected');
export const bulkAction = createAction('curveManager/bulkAction');
export const bulkActionResolved = createAction('curveManager/bulkAction/resolved');
export const bulkActionRejected = createAction('curveManager/bulkAction/rejected');
export const deleteCurve = createAction('curveManager/deleteCurve');
export const deleteCurveResolved = createAction('curveManager/deleteCurveResolved');
export const deleteCurveRejected = createAction('curveManager/deleteCurveResolved');
export const checkDuplicateCurveById = createAction('curveManager/getCurveById');
export const checkDuplicateCurveByIdResolved = createAction('curveManager/getCurveById/resolved');
export const checkDuplicateCurveByIdRejected = createAction('curveManager/getCurveById/rejected');
